import { Collapse } from 'antd';
import './AccordianInput.css';

import InputDescription from '../quiz-input-show-description/quiz-input-show-description';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import React from 'react';

const { Panel } = Collapse;

const InputsAccordian = ({
  name,
  title,
  description,
  indexKey,
  accordionQuestions,
  renderInputFieldsHandler,
  questionTooltip
}) => {
  //TO RENDER DESCRIPTION OF INPUTS
  function ShowDescription(description) {
    return <InputDescription description={description} descriptionColor={'#4A4845'} questionTooltip={questionTooltip} />;
  }
  return (
    <Collapse
      expandIconPosition="end"
      className="collapse-container"
      expandIcon={({ isActive }) =>
        isActive ? (
          <UpOutlined style={{ color: 'white' }} />
        ) : (
          <DownOutlined style={{ color: '#003E69' }} />
        )
      }
    >
      <Panel header={title} key={''}>
        <>{description && ShowDescription(description)}</>
        {accordionQuestions &&
          accordionQuestions?.map((field, index) => {
            return (
              <React.Fragment key={indexKey + index}>
                {field?.fields?.questionRequirements ? (
                  <div className="requirement-border">
                    {renderInputFieldsHandler(field, indexKey + index)}
                  </div>
                ) : (
                  <>{renderInputFieldsHandler(field, indexKey + index)}</>
                )}
              </React.Fragment>
            );
          })}
      </Panel>
    </Collapse>
  );
};

export default InputsAccordian;
